import axios from "axios";
import { groupBy } from "lodash";
import { InvoicePerMonth } from "../types/invoice";

export const InvoiceTransport = {
    list: async (): Promise<InvoicePerMonth> => {
        const { data } = await axios.get(`/invoicePerMonth`, {});
        const groudedByYear = groupBy(data, (d) => d?.year);
        const finaldata = [];
        let id = 1;
        for (const key in groudedByYear) {
            let months = {};
            groudedByYear[key].forEach((el) => {
                months = { ...months, [el?.month?.toLocaleLowerCase()]: el.total };
            });

            finaldata.push({ id, year: parseInt(key, 10), ...months });
            id++;
        }

        return finaldata;
    },
};
